import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useAemConfig } from '@as-react/common-components';
import { ButtonAlpha, Sidebar, useMediaQueryMatchesOnDesktop, useMediaQueryMatchesOnMobile, } from '@yonderland/andes-react';
import { useDebounce, useScrollPosition } from '@as/cotopaxi';
import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { I18N_NAMESPACES } from '../../../../constants/i18nConstants';
import { DELAY } from '../../../../constants/GeneralConstants';
import { makeGetBasketMappedProductsState } from '../../../../redux/basket/selectors/BasketSelector';
import checkoutActions from '../../../../redux/checkout/actions/CheckoutActions.creators';
import { makeGetCheckoutStatus } from '../../../../redux/checkout/selectors/CheckoutSelector';
import { CheckoutStatus } from '@as-react/common-types';
import { useOAuth } from '../../../../hooks/useOAuth';
import { useFeatureToggle } from '../../../../hooks/useFeatureToggle';
import { makeGetIsLoggedIn } from '../../../../redux/session/selectors/SessionSelector';
export const ProceedCheckoutCTA = ({ disabled }) => {
    const { t } = useTranslation(I18N_NAMESPACES.checkout);
    const { root } = useAemConfig();
    const isDesktop = useMediaQueryMatchesOnDesktop();
    const isMobile = useMediaQueryMatchesOnMobile();
    const [isSidebarHidden, setIsSidebarHidden] = useState(true);
    const [buttonPosition, setButtonPosition] = useState(0);
    const [clientHeight, setClientHeight] = useState(0);
    const [proceedButton, setProceedButton] = useState();
    const { authUrl, loggedIn: oauthLoggedIn } = useOAuth({ returnTo: `${root}buy.html`, flow: 'checkout' });
    const isNewAuth = useFeatureToggle('use_new_auth_flow');
    const isLoggedIn = useSelector(makeGetIsLoggedIn()) || oauthLoggedIn;
    const dispatch = useDispatch();
    const products = useSelector(makeGetBasketMappedProductsState());
    const { state } = useSelector(makeGetCheckoutStatus());
    const isDisabled = disabled || [CheckoutStatus.INITIALIZING, CheckoutStatus.INITIALIZED].includes(state);
    const updatePosition = () => {
        if (proceedButton) {
            const top = proceedButton.getBoundingClientRect().top + proceedButton.getBoundingClientRect().height + window.pageYOffset;
            setButtonPosition(top);
        }
    };
    const handleSetHidden = () => {
        const isHiddenStickyBar = proceedButton && proceedButton.getBoundingClientRect().bottom < window.innerHeight;
        setIsSidebarHidden(Boolean(isHiddenStickyBar));
    };
    const proceedButtonRef = useCallback((node) => {
        if (node !== null) {
            setProceedButton(node);
        }
    }, []);
    const updateWithDelay = useDebounce(() => {
        setClientHeight(window.innerHeight);
        updatePosition();
    }, DELAY.DELAY_20);
    const onClickCheckout = () => {
        dispatch(checkoutActions.createInitAction({ hrefCheckout: isNewAuth && !isLoggedIn ? authUrl : `${root}buy.html` }));
    };
    useEffect(() => {
        updatePosition();
    }, [proceedButton, products.length, isMobile, isDesktop]);
    useEffect(() => {
        updatePosition();
        window.addEventListener('resize', updateWithDelay);
        return () => window.removeEventListener('resize', updatePosition);
    }, []);
    useEffect(() => {
        handleSetHidden();
    }, [buttonPosition, clientHeight]);
    useScrollPosition(handleSetHidden, [buttonPosition]);
    return (_jsxs(_Fragment, { children: [_jsx(ButtonAlpha, { fullWidth: true, innerRef: proceedButtonRef, theme: "branded", testId: "checkout_button", state: isDisabled ? 'disabled' : undefined, text: t('checkout.basket.order'), onClick: onClickCheckout }), !isDesktop && !isSidebarHidden && (_jsx(Sidebar, { isOpen: true, side: "right", align: "bottom", position: "fixed", animation: "none", zIndex: "sticky", hasCloseBtn: false, hasBackdrop: false, fullHeight: false, customWidth: "100%", children: _jsx(ButtonAlpha, { fullWidth: true, theme: "branded", testId: "checkout_button", state: isDisabled ? 'disabled' : undefined, text: t('checkout.basket.order'), onClick: onClickCheckout }) }))] }));
};
